import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaceCoreModule, WidgetsModule } from '@evorait/pace-core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CoreModule } from '../core/core.module';
import { DetailsModule } from '../details/details.module';
import { MaterialModule } from '../material/material.module';
import { MileageModule } from '../mileage/mileage.module';
import { SharedModule } from '../shared/shared.module';
import { TimesheetModule } from '../timesheet/timesheet.module';
import { DashboardNotificationComponent } from './components/dashboard-notification/dashboard-notification.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { TabsModule } from 'ngx-bootstrap/tabs';

@NgModule({
    declarations: [DashboardComponent, NotificationListComponent, DashboardNotificationComponent],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        ModalModule,
        MaterialModule,
        TimesheetModule,
        DetailsModule,
        WidgetsModule,
        MileageModule,
        PaceCoreModule.forChild(),
        TabsModule,
    ],
})
export class DashboardModule {}
